module.exports = __webpack_public_path__ + "2d29b8eba4285f574d9591e2bab67939.png";